export const BIO_CATEGORIES = ['MAGAZINE', 'MODA', 'CELEBRIDADES', 'BELEZA', 'NOTÍCIAS', 'REALITY', 'ESPORTES', 'MÚSICA', 'CINEMA/TV', 'BEM ESTAR', 'SAÚDE', 'TECH', 'MONEY', 'EMPREENDEDORISMO', 'EXCLUSIVAS'] as const

export type BioCategory = typeof BIO_CATEGORIES[number]
